import * as React from "react";
import { SVGProps } from "react";
const SvgWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 20a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0-5c1.9 0 3.6.7 5 2.1.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0-1-1-2.3-1.5-3.6-1.5-1.3 0-2.6.5-3.5 1.5-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4 1.3-1.3 3.1-2.1 4.9-2.1Zm0-5c3.2 0 6.2 1.2 8.5 3.5.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3C21.2 13 18.7 12 16 12c-2.7 0-5.2 1-7.1 2.9-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4C9.8 11.2 12.8 10 16 10Zm0-5c4.4 0 8.6 1.7 11.7 4.8.4.4.4 1 0 1.4-.2.2-.5.3-.7.3a.881.881 0 0 1-.614-.22l-.086-.08C23.5 8.5 19.9 7 16 7c-3.9 0-7.5 1.5-10.3 4.2-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4C7.4 6.7 11.6 5 16 5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWifi;
